export const light = {
  alternate: {
    main: '#efeceb',
    dark: '#d9cecd',
  },
  cardShadow: 'rgb(130 155 160 / 11%)',
  mode: 'light',
  custom: {

    md: '#f9efe9',
    pink: '#f4e1d5',
    ltPink: '#fbf5f1',
    kakhi: '#848058',
    burgundy: '#6A2226',
    gray: '#bfbfc1',
    ltGray: '#f0f0f0',
    50: '#ecece6',
    100: '#c6c5b9',
    200: '#a3a295',
    300: '#8a8873',
    400: '#7B785C',
    500: '#656141',
  },
  secondary: {
    50: '#fff7f5',
    100: '#faeae8',
    200: '#f6dddb',
    300: '#efcdc9',
    400: '#e6bcb7',
    500: '#ddaba6',
    600: '#cd9f9a',
    700: '#b88f8c',
    800: '#a68281',
    900: '#937274',
    main: '#b88f8c',
  },
  primary: {
    50: '#efeceb',
    100: '#d9cecd',
    200: '#c0aeac',
    300: '#a78c8a',
    400: '#957370',
    500: '#825a57',
    600: '#75514f',
    700: '#654544',
    800: '#55393a',
    900: '#442c2e',
    main: '#825a57'
  },
  text: {
    primary: '#4e2f33',
    secondary: '#55393a',
    lt: '#735f62',
    light: 'rgb(103, 119, 136)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#ffffff',
    default: '#ffffff',
    level2: '#f5f5f5',
    level1: '#ffffff'
  }
}

export const dark = {
  alternate: {
    main: '#1a2138',
    dark: '#151a30'
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff'
  },
  mode: 'dark',
  primary: {
    main: '#1976d2',
    light: '#2196f3',
    dark: '#0d47a1',
    contrastText: '#fff'
  },
  secondary: {
    light: '#FFEA41',
    main: '#FFE102',
    dark: '#DBBE01',
    contrastText: 'rgba(0, 0, 0, 0.87)'
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#222B45',
    default: '#222B45',
    level2: '#333',
    level1: '#2D3748'
  }
}
